module.exports = __webpack_public_path__ + "img/icon_online.d1d05765.svg";